import { TASKS_URL } from "../constants";
import { apiSlice } from "./apiSlice";



export const tasksApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTasks: builder.query({
            query: () => ({
                url: TASKS_URL,
            }),
            keepUnusedDataFor:5
        }),
        getTaskDetails: builder.query({
            query: (taskId) => ({
                url: `${TASKS_URL}/${taskId}`,
            }),
            keepUnusedDataFor:5
        }),
        createTask: builder.mutation({
            query: (data) => ({
                url: TASKS_URL,
                method: 'POST',
                body: data,
            }),
            invalidatesTags:['Tasks']
        }),
        getTasksBySite: builder.query({
            query: (siteId) => ({
                url: `${TASKS_URL}/site/${siteId}`,
            }),
            invalidatesTags:['Tasks']
        }),
        updateTask: builder.mutation({
            query: (data) => ({
                url: `${TASKS_URL}/${data._id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags:['Tasks']
        }),
        markComplete: builder.mutation({
            query: (data) => ({
                url: `${TASKS_URL}/${data._id}/complete`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags:['Tasks']
        }),
        deleteTask: builder.mutation({
            query: (taskId) => ({
                url: `${TASKS_URL}/${taskId}`,
                method: 'DELETE',
            }),
        }),
    })
});

export const {useGetTasksQuery, useGetTaskDetailsQuery, useGetTasksBySiteQuery, useCreateTaskMutation, useUpdateTaskMutation, useDeleteTaskMutation, useMarkCompleteMutation} = tasksApiSlice;